import { numValidResults, FEES } from "./constants";

export function tryParse<T>(objString: string): T {
    try {
        if (objString) {
            return JSON.parse(objString);
        }
    } catch (err) {
        return null;
    }
    return null;
}

export function compareNumbersAsc(a, b) {
    return a - b;
}

//convert number to string currency
export function floatToCurrency(value) {
    return parseFloat(value).toFixed(2);
}

export function compareNumbersDesc(a, b) {
    return b - a;
}

export function createFeesObject(data) {
    const datum = data;
    //set the fees by name
    for (const i in FEES) {
        FEES[i].fee = getFeeByName(datum.Fees, FEES[i].name);
    }

    FEES.POINTS.fee = 100 - data.Price;
    FEES.TITLE_FEES.fee = FEES.RECORDING.fee + FEES.TITLE_SERVICES.fee + FEES.CLOSING.fee + FEES.TITLE_ENDORSEMENT.fee;
    FEES.TOTAL_THIRD_PARTY.fee = FEES.TITLE_FEES.fee + FEES.CREDIT_REPORT.fee + FEES.APPRAISAL.fee + (FEES.INSPECTION.fee || 0) + (FEES.FINAL_REINSPECTION.fee || 0);
    FEES.TOTAL_LENDER_FEES.fee = FEES.LOAN_ORIGINATION.fee + FEES.PROCESSING.fee + FEES.POINTS.fee;
    datum.Fees = FEES;
    return datum;
}

export function getFeeByName(fees, name) {
    const feeObj = fees.find(fee => {
        return fee.Name.match(name);
    });

    if (feeObj) {
        return feeObj.Amount
    } else {
        // Set null for inspection fee to be hidden if not found
        return name === FEES.INSPECTION.name || name === FEES.FINAL_REINSPECTION.name ? null : 0;
    }
}

//make sure the loan ntype is
export function getEachInitialLoanType(loanTypes) {
    // Find the first enabled loan type
    const returnLoanTypes = [];
    for (let i = 0; i < loanTypes.length; i++) {
        const loanType = loanTypes[i];
        if (loanType.options.length >= numValidResults) {
            returnLoanTypes.push(loanTypes[i]);
        }
    }

    return returnLoanTypes;
}

export function getLoanToValue(loanAmount, purchasePrice) {
    const loanToValue = (loanAmount / purchasePrice) * 100;
    return loanToValue.toFixed(2) + "%";
}

export function getInitialLoanType(loanTypes) {

    for (let i = 0; i < loanTypes.length; i++) {
        const loanType = loanTypes[i];
        if (loanType.options.length >= numValidResults) {
            return loanTypes[i];
        }
    }

    return 0;
}

export function getParPointsIndex(options) {
    let max = -Infinity;
    let maxIndex = 0;

    let min = Infinity;
    let minIndex = 0;

    for (let i = 0; i < options.length; i++) {
        const { points } = options[i];

        // We're looking for 0
        if (points === 0) {
            return options[i];
        }
        // Find the biggest negative number
        if (points < 0 && points > max) {
            max = points;
            maxIndex = i;
        }

        // Keep track of the smallest positive number
        if (points > 0 && points < min) {
            min = points;
            minIndex = i;
        }
    }

    // If we didn't find any negative numbers or 0
    // return the smallest positive number index
    if (max === -Infinity) {
        return options[minIndex];
    }

    // return biggest negative number index
    return options[maxIndex];
}

// construction loans return different payment count variables
// so we need to find them or else we get NaNaNaNa
export function getPaymentCountById(id, disclosureInformation) {
    //TODO: may need to make this a switch later if different IDs
    //return different terms/paymentCounts
    if (id === 42 || disclosureInformation.isBalloonLoan) {
        return disclosureInformation.termMonths;
    }

    return disclosureInformation.paymentCount;
}

export function getPaymentCount(disclosureInformation) {
    if (disclosureInformation.isBalloonLoan && disclosureInformation.termMonths) {
        return disclosureInformation.termMonths;
    }
    
    return disclosureInformation.paymentCount ? disclosureInformation.paymentCount : disclosureInformation.termMonths;
}
